import React from "react";
import { motion } from "framer-motion";
import { ChatCircleDots } from "@phosphor-icons/react";

const FORM_URL = "https://forms.gle/nyaHMAdRzsVuq2YE9";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.1 },
  }),
};

export default function Feedback() {
  return (
    <section id="feedback" className="py-24 lg:py-32" data-testid="feedback-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <motion.div variants={fadeUp} custom={0} className="mb-6">
            <ChatCircleDots size={40} weight="regular" style={{ color: '#FF5A36' }} className="mx-auto" />
          </motion.div>
          <motion.p
            variants={fadeUp}
            custom={1}
            className="font-accent text-sm tracking-[0.25em] uppercase mb-4"
            style={{ color: '#FF5A36' }}
          >
            We Want to Hear From You
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={2}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-6"
            style={{ color: '#F0EDE5' }}
          >
            How's Your Scrub?
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={3}
            className="font-body text-base leading-relaxed mb-10 max-w-lg mx-auto"
            style={{ color: '#9A9A9A' }}
          >
            Tried our bars? Tell us about your experience. Your feedback helps us keep making the best soap on the planet.
          </motion.p>
          <motion.a
            variants={fadeUp}
            custom={4}
            href={FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 text-sm font-accent font-semibold tracking-wider uppercase text-white transition-all duration-300 hover:brightness-110"
            style={{ backgroundColor: '#FF5A36' }}
            data-testid="feedback-survey-btn"
          >
            Take the Survey
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
